import React from 'react';
import {useTranslation} from 'react-i18next';
import {Card, CardBody, Col} from 'reactstrap';
import {LocaleLink} from '@/routes';
import Separator from '@/views/shared/Separator';
import styles from '@/views/Activation/index.module.css';

const ActivateSuccuss = ({loginId}) => {
  const {t: tr} = useTranslation('activation');

  return (
    <Card>
      <CardBody className={styles.section}>
        <div className='text-center'>
          <br />
          <h1 className={styles.title}>{tr('online_reg_title')}</h1>
          <Separator />
          <h3 className={styles.subtitle}>
            {tr('activate_success_sub_title')}
          </h3>
          <br />
          <br />
          <span>{tr('activate_success_content_line1')}</span>
          <br />
          <span>{tr('activate_success_content_line2', {loginId})}</span>
          <br />
          <br />
          <Col md={{size: 6, offset: 3}}>
            <LocaleLink
              to='/login'
              className='btn btn-secondary btn-lg btn-block'
            >
              {tr('go_to_login')}
            </LocaleLink>
          </Col>
        </div>
      </CardBody>
    </Card>
  );
};

export default ActivateSuccuss;
